import { breakpoints } from '../tokens';

import type { BreakpointsOptions } from '@mui/system';

/**
 * Customized breakpoints for Material-UI Design System.
 * (https://mui.com/material-ui/customization/breakpoints)
 *
 * - `xs`: extra-small, mobile device
 * - `sm`: small, small tablet device
 * - `md`: medium, tablet device
 * - `lg`: large, laptop device
 * - `xl`: extra-large, desktop device
 */
type HeightBreakPointOptions = {
  height: {
    tablet: number;
    notebook: number;
    desktop: number;
  };
};
type AIDTBreakpointsOptions = BreakpointsOptions & HeightBreakPointOptions;

export const AIDTBreakpoints: AIDTBreakpointsOptions = Object.freeze({
  values: {
    xs: breakpoints.xs,
    sm: breakpoints.sm,
    md: breakpoints.md,
    lg: breakpoints.lg,
    xl: breakpoints.xl,
  },
  height: {
    tablet: breakpoints.tablet,
    notebook: breakpoints.notebook,
    desktop: breakpoints.desktop,
  },
});
